import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTelegram } from '../../hooks/useTelegram';
import { useAuth } from '../../context/AuthContext';
import { Button } from '../../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../../components/ui/card';
import { Send, Mail } from 'lucide-react';

export default function TelegramWelcome() {
 const { initData } = useTelegram();
 const { loginWithTelegram } = useAuth();
 const navigate = useNavigate();
 const location = useLocation();
 const [loading, setLoading] = useState(false);

 const handleTelegramLogin = async () => {
 setLoading(true);
 try {
 const success = await loginWithTelegram(initData);
 if (success) {
 // Check for stored deep link first
 const deepLink = sessionStorage.getItem('telegram_deep_link');
 if (deepLink) {
 sessionStorage.removeItem('telegram_deep_link');
 navigate(deepLink, { replace: true });
 } else {
 // Redirect back to original path or default dashboard
 const from = location.state?.from || '/applier/dashboard';
 navigate(from, { replace: true });
 }
 }
 } catch (error) {
 console.error("Login failed", error);
 } finally {
 setLoading(false);
 }
 };

 return (
 <div className="min-h-screen flex items-center justify-center p-4">
 <Card className="w-full max-w-md">
 <CardHeader className="text-center">
 <CardTitle className="text-2xl font-bold">Welcome to JobPortal</CardTitle>
 <CardDescription>
 Find your dream job or hire top talent directly from Telegram.
 </CardDescription>
 </CardHeader>
 <CardContent className="space-y-4">
 <Button 
 className="w-full bg-sky-600 hover:bg-sky-600/90 text-white h-12 text-lg"
 onClick={handleTelegramLogin}
 disabled={loading}
 >
 <Send className="mr-2 h-5 w-5" />
 {loading ? 'Logging in...' : 'Continue with Telegram'}
 </Button>
 
 <div className="relative text-center text-sm after:absolute after:inset-0 after:top-1/2 after:z-0 after:flex after:items-center after:border-t after:border-border">
 <span className="relative z-10 px-2 text-muted-foreground">
 OR
 </span>
 </div>

 <Button 
 variant="outline" 
 className="w-full h-12"
 onClick={() => navigate('/login')}
 >
 <Mail className="mr-2 h-5 w-5" />
 Login with Email
 </Button>
 </CardContent>
 </Card>
 </div>
 );
}
